class ImageGalleryItem extends Component {

    /**
     * @param {HTMLElement} el
     */
    constructor(el) {
        super(el);
    }
}
